<div class="home-container">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-background">
      <div class="hero-gradient"></div>
      <div class="hero-pattern"></div>
    </div>
    
    <!-- Floating Elements -->
    <div class="floating-elements">
      <div class="float-element element-1"></div>
      <div class="float-element element-2"></div>
      <div class="float-element element-3"></div>
      <div class="float-element element-4"></div>
    </div>

    <div class="container">
      <div class="hero-content" [@fadeInUp]>
       
        
        <p class="hero-subtitle">
          Aadinath Enterprises - Your trusted partner in premium bag solutions for global export and import business. We craft excellence in every stitch, delivering world-class quality to over 50 countries.
        </p>

        <!-- Hero Metrics -->
        <div class="hero-metrics" [@staggerCards]>
          <div *ngFor="let metric of heroMetrics" class="metric-card">
            <div class="metric-icon">{{ metric.icon }}</div>
            <div class="metric-content">
              <div class="metric-number">{{ metric.number }}</div>
              <div class="metric-label">{{ metric.label }}</div>
            </div>
          </div>
        </div>

        <!-- Hero Actions -->
        <div class="hero-actions">
          <button class="btn-primary" (click)="scrollToProducts()">
            <span>Explore Products</span>
          </button>
          <button class="btn-secondary" (click)="exploreCollection()">
            <a routerLink="/products" routerLinkActive="active" class="nav-link" style="text-decoration: none; color: white;">
              <span>View Collection</span>
            </a>
          </button>
        </div>
      </div>
    </div>
  </section>


  <!-- Products Section -->
  <section class="products-section" id="products">
    <div class="container">
      <div class="section-header" [@slideInRight]>
        <div class="section-badge">
          🎯 Featured Products
        </div>
        <!-- <h2 class="section-title">Premium Quality Products</h2> -->
        <p class="section-subtitle">
          Our commitment to innovation, quality, and global standards makes us the preferred partner for premium bag manufacturing worldwide.
        </p>
      </div>

      <div class="products-grid" [@staggerCards]>
        <div *ngFor="let product of products" class="product-card">
          <!-- Product Image -->
          <div class="product-image-container">
            <img [src]="product.image" [alt]="product.name" class="product-image">
            
            <!-- Product Overlay -->
            <div class="product-overlay">
              <div class="overlay-actions">
                <button mat-icon-button class="overlay-btn" (click)="viewProductDetails(product)" title="View Details">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button class="overlay-btn" (click)="knowMoreOnWhatsApp(product)" title="WhatsApp Inquiry">
                  <mat-icon>chat</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Product Info -->
          <div class="product-info">
            <div class="product-meta">
              <span class="product-category">{{ getCategoryDisplayName(product.category) }}</span>
              <div class="product-rating">
                <mat-icon *ngFor="let star of getStars(product.rating)" 
                         [class.filled]="star === 1">star</mat-icon>
                <span class="rating-text">({{ product.reviews || 45 }})</span>
              </div>
            </div>
            
            <h3 class="product-name">{{ product.name }}</h3>
            <p class="product-description">{{ product.description }}</p>
            <div class="product-price">{{ product.price }}</div>
            
            <div class="product-actions">
              <button class="add-to-cart-btn" (click)="viewProductDetails(product)">
                <mat-icon>visibility</mat-icon>
                <span>View Details</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- Features Section -->
  <section class="features-section">
    <div class="container">
      <div class="section-header" [@slideInLeft]>
        <div class="section-badge">
          ✨ Why Choose Us
        </div>
        <!-- <h2 class="section-title">Our Excellence</h2> -->
        <p class="section-subtitle">
          Discover our signature collection designed for international markets and premium business applications.
        </p>
      </div>

      <div class="features-grid" [@staggerCards]>
        <div *ngFor="let feature of features; let i = index" class="feature-card">
          <div class="feature-number">{{ (i + 1).toString().padStart(2, '0') }}</div>
          <div class="feature-icon-container">
            <div class="feature-icon">{{ feature.icon }}</div>
            <div class="feature-glow"></div>
          </div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
          <a href="#" class="feature-link">
            Learn More →
          </a>
        </div>
      </div>
    </div>
  </section>


  <!-- CTA Section -->
  <section class="cta-section">
    <div class="cta-background">
      <div class="cta-gradient"></div>
      <div class="cta-pattern"></div>
    </div>

    <div class="container">
      <div class="cta-content" [@scaleIn]>
        <div class="cta-badge">
          🚀 Ready to Start?
        </div>
        
        <h2 class="cta-title">Let's Build Something Great Together</h2>
        <p class="cta-description">
          Join over 1000+ successful businesses who trust Aadinath Enterprises for their premium bag manufacturing and global export needs. Let's build something extraordinary together.
        </p>

        <div class="cta-actions">
          <button class="btn-cta">
            <span>Get Started</span>
            <div class="btn-glow"></div>
          </button>

          <button class="btn-cta-secondary">
            <a routerLink="/contact" routerLinkActive="active" style="text-decoration: none; color: white;">
              <span>Contact Us</span>
            </a>
          </button>
        </div>

        <!-- Trust Indicators -->
        <div class="trust-indicators">
          <div class="trust-item">
            <mat-icon>verified</mat-icon>
            <span>ISO Certified</span>
          </div>
          <div class="trust-item">
            <mat-icon>local_shipping</mat-icon>
            <span>Global Shipping</span>
          </div>
          <div class="trust-item">
            <mat-icon>support_agent</mat-icon>
            <span>24/7 Support</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Product Details Modal -->
<div *ngIf="showProductDetails" class="product-details-overlay" (click)="closeProductDetails()">
  <div class="product-details-modal" (click)="$event.stopPropagation()" [@slideIn]>
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ selectedProduct?.name }}</h2>
      <button mat-icon-button class="close-btn" (click)="closeProductDetails()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="product-details-grid">
        <!-- Product Image -->
        <div class="details-image-section">
          <img [src]="selectedProduct?.image" [alt]="selectedProduct?.name" class="details-image">
        </div>

        <!-- Product Information -->
        <div class="details-info-section">
          <!-- Basic Info -->
          <div class="basic-info">
            <div class="product-meta">
              <span class="product-category">{{ getCategoryDisplayName(selectedProduct?.category || '') }}</span>
              <div class="product-rating">
                <div class="stars">
                  <mat-icon *ngFor="let star of getStars(selectedProduct?.rating || 0)" [class.filled]="star === 1">star</mat-icon>
                </div>
                <span class="rating-text">({{ selectedProduct?.reviews || 45 }} reviews)</span>
              </div>
            </div>

            <p class="product-description">{{ selectedProduct?.description }}</p>

            <!-- Price Info -->
            <div class="price-section">
              <div class="price-info">
                <span class="current-price">{{ selectedProduct?.price }}</span>
              </div>
            </div>
          </div>

          <!-- Detailed Specifications -->
          <div class="specifications-section">
            <h3 class="section-title">
              <mat-icon>info</mat-icon>
              Product Specifications
            </h3>
            
            <div class="specs-grid">
              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>texture</mat-icon>
                  Material
                </div>
                <div class="spec-value">Cotton, Canvas, Jute & Polypropylene (Hubco)</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>straighten</mat-icon>
                  Size Options
                </div>
                <div class="spec-value">6x8, 8x10, 10x12, 12x14, 14x16, 16x18 and customize</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>palette</mat-icon>
                  Available Colors
                </div>
                <div class="spec-value">White and Off White</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>scale</mat-icon>
                  Capacity Range
                </div>
                <div class="spec-value">100 grams to 10kg or more</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>flag</mat-icon>
                  Country of Origin
                </div>
                <div class="spec-value">Made in India</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>shopping_cart</mat-icon>
                  Minimum Order
                </div>
                <div class="spec-value">5000 Bags</div>
              </div>
            </div>
          </div>

          <!-- Product Features -->
          <div class="features-section">
            <h3 class="section-title">
              <mat-icon>stars</mat-icon>
              Key Features
            </h3>
            
            <div class="features-content">
              <p class="features-description">
                Cotton bags for Geological soil samples are designed for the collection of rock, mineral, and geochemical soil samples. 
                All bags have a drawstring closure and sewn in 2" x 3" waterproof white tag. The tags are double-sided with one side 
                blank and the other with a standard sample format.
              </p>

              <div class="feature-highlights">
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Writable Panels</strong> – For clear labeling and sample ID tracking</span>
                </div>
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Multiple Sizes Available</strong> – Perfect for everything from handheld grab samples to bulk collections</span>
                </div>
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Waterproof Tags</strong> – Durable identification in all weather conditions</span>
                </div>
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Drawstring Closure</strong> – Secure and easy-to-use closure system</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
      <button mat-button class="action-btn secondary" (click)="closeProductDetails()">
        <mat-icon>close</mat-icon>
        Close
      </button>
      <button mat-button class="action-btn primary" (click)="knowMoreOnWhatsApp(selectedProduct!)">
        <mat-icon>chat</mat-icon>
        WhatsApp Inquiry
      </button>
    </div>
  </div>
</div>
